import React from 'react';
import ClassConfirmation from '@/components/class-wizard/ClassConfirmation';
import { ClassWizardProvider } from '@/components/class-wizard/ClassWizardContext';

const ClassConfirmationPage = () => {
  return (
    <ClassWizardProvider>
      <ClassConfirmation />
    </ClassWizardProvider>
  );
};

export default ClassConfirmationPage; 